import React from 'react'

export default function Legal() {
  return (
    <div>Legal</div>
  )
}
